/**
 * Kombinierter Land-/Sprachwähler (2026-08-24).
 *
 * Bewusst NICHT Dawns `localization-form.js`: Das liest pro Formular nur EIN
 * verstecktes Feld und würde bei unseren zwei Feldern immer das falsche setzen.
 * Hier trägt jeder Link über `data-field`, welches Feld er füllt.
 */
if (!customElements.get('wb-locale-picker')) {
  customElements.define(
    'wb-locale-picker',
    class WbLocalePicker extends HTMLElement {
      connectedCallback() {
        this.knopf = this.querySelector('.wb-locale-picker__button');
        this.panel = this.querySelector('.wb-locale-picker__panel');
        this.formular = this.querySelector('form');
        if (!this.knopf || !this.panel || !this.formular) return;

        this.knopf.addEventListener('click', this.umschalten.bind(this));
        this.addEventListener('keyup', this.beiTaste.bind(this));
        this.addEventListener('focusout', this.beiFokusVerlust.bind(this));
        this.querySelectorAll('.wb-locale-picker__link').forEach((link) => {
          link.addEventListener('click', this.beiAuswahl.bind(this));
        });

        /* Ein Klick irgendwo sonst schliesst das Panel. Am Dokument, weil ein
           Klick auf nicht-fokussierbare Flächen kein focusout auslöst. */
        this.beiDokumentKlick = (ereignis) => {
          if (!this.contains(ereignis.target)) this.schliessen();
        };
        document.addEventListener('click', this.beiDokumentKlick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.beiDokumentKlick);
      }

      umschalten(ereignis) {
        ereignis.stopPropagation();
        if (this.knopf.getAttribute('aria-expanded') === 'true') {
          this.schliessen();
        } else {
          this.oeffnen();
        }
      }

      oeffnen() {
        /* Andere offene Wähler auf der Seite zuklappen (Topbar, Footer, Menü). */
        document.querySelectorAll('wb-locale-picker').forEach((anderer) => {
          if (anderer !== this && typeof anderer.schliessen === 'function') anderer.schliessen();
        });
        this.panel.removeAttribute('hidden');
        this.knopf.setAttribute('aria-expanded', 'true');
      }

      schliessen() {
        if (!this.panel) return;
        this.panel.setAttribute('hidden', '');
        this.knopf.setAttribute('aria-expanded', 'false');
      }

      beiTaste(ereignis) {
        if (ereignis.code !== 'Escape' && ereignis.key !== 'Escape') return;
        if (this.knopf.getAttribute('aria-expanded') === 'false') return;
        this.schliessen();
        this.knopf.focus();
      }

      beiFokusVerlust(ereignis) {
        if (this.contains(ereignis.relatedTarget)) return;
        this.schliessen();
      }

      beiAuswahl(ereignis) {
        ereignis.preventDefault();
        const link = ereignis.currentTarget;
        const feld = this.formular.querySelector('input[name="' + link.dataset.field + '"]');
        if (!feld) return;
        feld.value = link.dataset.value;
        this.formular.submit();
      }
    },
  );
}
